import axios from "axios";
import {
  AUTH_ERROR,
  GOOGLE_SIGN_IN,
  AUTH_LINK_GOOGLE,
  AUTH_UNLINK_GOOGLE,
  DASHBOARD_GET_DATA,
  MESSAGELOG_DATA,
  MESSAGELOG_DATA_AGR_CUSTOMER,
  MESSAGELOG_DATA_AGR_CUSTOMER_START,
  GOOGLE_SIGN_OUT,
  MESSAGELOG_DATA_AGR_DEVICE_DATA,
  MESSAGELOG_DATA_READBLOB,
  MESSAGELOG_DATA_READBLOB_START,
  MESSAGELOG_DATA_DETAILED_DATA_START,
  CUSTOMER_ADD,
  CUSTOMER_DATA,
  CUSTOMER_ADD_LOADER,
  CUSTOMER_TOGGLE_ACTIVE,
  CUSTOMER_DELETED,
  CUSTOMER_EDIT,
  CUSTOMER_SERVER_DATA,
  CUSTOMER_RESET_SUCCESS,
  SERVER_ADD_LOADER,
  SERVER_DATA,
  SERVER_ADD,
  SERVER_TOGGLE_ACTIVE,
  SERVER_DELETED,
  SERVER_EDIT,
  SERVER_RESET_SUCCESS,
  USER_DATA,
  USER_ADD,
  USER_ADD_LOADER,
  USER_EDIT,
  USER_DELETED,
  USER_RESET_SUCCESS,
  USER_DATA_BY_ROLE,
  MESSAGELOG_DATA_SETLOADER,
} from "./types";
import { apiUrl } from "../config";
import { checkLoginStatus } from "./authAction";
import * as fileSaver from "file-saver";
import history from "../utils/history";

export const signinWithGoogle = (data) => {
  return async (dispatch) => {
    try {
      const { accessToken, profile } = data;
      const res = await axios.post(`${apiUrl}auth/google`, {
        access_token: accessToken,
      });
      const {
        data: { token, status, message, user },
      } = res;

      if (status) {
        dispatch({
          type: GOOGLE_SIGN_IN,
          payload: {
            ...user,
            authToken: token,
          },
        });

        axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
        localStorage.setItem("auth-token", token);
        localStorage.setItem("user", JSON.stringify(user));
      } else if (message === "Non-Orange") {
        history.push("/NoOrangesoftwareDomain");
      }
    } catch (err) {
      dispatch({
        type: AUTH_ERROR,
        payload: err,
      });
    }
  };
};

export const linkGoogle = (data) => {
  return async (dispatch) => {
    const res = await axios.post(`${apiUrl}auth/link/google`, {
      access_token: data,
    });

    dispatch({
      type: AUTH_LINK_GOOGLE,
      payload: res.data,
    });
  };
};

export const unlinkGoogle = (data) => {
  return async (dispatch) => {
    const res = await axios.post(`${apiUrl}auth/unlink/google`);

    dispatch({
      type: AUTH_UNLINK_GOOGLE,
      payload: res.data,
    });
  };
};

export const checkAuth = (data) => {
  return async (dispatch) => {
    const authToken = localStorage.getItem("auth-token");
    const userString = localStorage.getItem("user");
    let user;
    if (userString) {
      user = JSON.parse(userString);
    }
    if (!user || !authToken) {
      dispatch(signOut());
      return;
    }

    axios.defaults.headers.common["Authorization"] = `bearer ${authToken}`;
    dispatch({
      type: GOOGLE_SIGN_IN,
      payload: {
        ...user,
        authToken,
      },
    });
  };
};

export const getDashboard = () => {
  return async (dispatch) => {
    try {
      const res = await axios.get(`${apiUrl}users/dashboard`);
      dispatch({
        type: DASHBOARD_GET_DATA,
        payload: res.data,
      });
    } catch (err) {}
  };
};

export const getMessageLog = (reqData) => {
  return async (dispatch) => {
    try {
      if (reqData.isShowChild === false) {
        dispatch({
          type: MESSAGELOG_DATA_DETAILED_DATA_START,
          payload: true,
        });
        const res = await axios.post(`${apiUrl}messages/messageLogs`, reqData);
        dispatch({
          type: MESSAGELOG_DATA,
          payload: {
            data: res.data,
            device2: reqData.device2,
          },
        });
      } else {
        dispatch({
          type: MESSAGELOG_DATA,
          payload: {
            data: [],
            device2: "",
          },
        });
      }
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_DETAILED_DATA_START,
        payload: false,
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const getDeviceMessageLog = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER_START,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}messages/deviceLogData`, reqData);
      if (!res.data || res.data.length === 0 || res.data[0].MAddress === "") {
        alert(
          "Device not found, reasons might be:\n1. Device wasn't transmitting at this date rage\n2. Spelling of device name "
        );
        res.data = [];
      }
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER_START,
        payload: false,
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const getCustomerMessageLog = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER_START,
        payload: true,
      });
      const res = await axios.post(
        `${apiUrl}messages/customerLogData`,
        reqData
      );
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER_START,
        payload: false,
      });
    }
  };
};
export const signOut = () => {
  return async (dispatch) => {
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("auth-token");
    localStorage.removeItem("user");
    dispatch({
      type: GOOGLE_SIGN_OUT,
    });
  };
};

export const getDeviceData = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGELOG_DATA_DETAILED_DATA_START,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}messages/deviceData`, reqData);
      dispatch({
        type: MESSAGELOG_DATA_AGR_DEVICE_DATA,
        payload: res.data,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

function base64ToArrayBuffer(base64) {
  let binary_string = window.atob(base64);
  let len = binary_string.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

export const readAzureBlobData = (reqData) => {
  return async (dispatch) => {
    try {
      let fileExt = reqData.blobUrl.substr(
        reqData.blobUrl.lastIndexOf(".") + 1
      );
      if (fileExt === "zip") {
        alert("This is a zip file, please download instead");
        return;
      }
      dispatch({
        type: MESSAGELOG_DATA_READBLOB_START,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}azure/readBlob`, reqData);

      let filename = reqData.blobUrl.replace(/^.*[\\\/]/, "");
      let blob;

      blob = new Blob([res.data.data], {
        type: "text/xml",
      });
      let tab = URL.createObjectURL(blob);
      window.open(tab, "_blank");
      URL.revokeObjectURL(tab);

      dispatch({
        type: MESSAGELOG_DATA_READBLOB,
      });
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER_START,
        payload: false,
      });
    }
  };
};

export const downloadAzureBlobData = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGELOG_DATA_READBLOB_START,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}azure/readBlob`, reqData);

      let fileExt = reqData.blobUrl.substr(
        reqData.blobUrl.lastIndexOf(".") + 1
      );
      let filename = reqData.blobUrl.replace(/^.*[\\\/]/, "");
      let blob;

      if (fileExt === "zip") {
        blob = new Blob([base64ToArrayBuffer(res.data.data)], {
          type: "application/" + fileExt,
        });
      } else {
        blob = new Blob([res.data.data], {
          type: "application/" + fileExt,
        });
      }

      fileSaver.saveAs(blob, filename);
      dispatch({
        type: MESSAGELOG_DATA_READBLOB,
      });
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_AGR_CUSTOMER_START,
        payload: false,
      });
    }
  };
};

export const deleteBlobMessage = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGELOG_DATA_SETLOADER,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}azure/deleteBlobMessage`, reqData);
      dispatch({
        type: MESSAGELOG_DATA_SETLOADER,
        payload: false,
      });
      alert(res.data.message);
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_SETLOADER,
        payload: false,
      });
    }
  };
};

export const resendBlobMessage = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: MESSAGELOG_DATA_SETLOADER,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}azure/resendBlobMessage`, reqData);
      dispatch({
        type: MESSAGELOG_DATA_SETLOADER,
        payload: false,
      });
      alert(res.data.message);
    } catch (err) {
      dispatch({
        type: MESSAGELOG_DATA_SETLOADER,
        payload: false,
      });
    }
  };
};

export const addCustomer = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${apiUrl}customer/addCustomer`, reqData);
      dispatch({
        type: CUSTOMER_ADD,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: CUSTOMER_ADD,
        payload: {
          success: false,
          message: "Request error!",
        },
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const editCustomer = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${apiUrl}customer/editCustomer`, reqData);
      dispatch({
        type: CUSTOMER_EDIT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: CUSTOMER_EDIT,
        payload: {
          success: false,
          message: "Request error!",
        },
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const getCustomerData = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CUSTOMER_ADD_LOADER,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}customer/customerData`, reqData);
      dispatch({
        type: CUSTOMER_DATA,
        payload: res.data,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
      dispatch({
        type: CUSTOMER_ADD_LOADER,
        payload: false,
      });
    }
  };
};

export const getCustomerServerData = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CUSTOMER_ADD_LOADER,
        payload: true,
      });
      const res = await axios.post(
        `${apiUrl}server/serverDataByCustomerId`,
        reqData
      );
      dispatch({
        type: CUSTOMER_SERVER_DATA,
        payload: res.data,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
      dispatch({
        type: CUSTOMER_ADD_LOADER,
        payload: false,
      });
    }
  };
};

export const setCustomerActiveStatus = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CUSTOMER_ADD_LOADER,
        payload: true,
      });
      await axios.post(`${apiUrl}customer/setActiveStatus`, reqData);
      dispatch({
        type: CUSTOMER_TOGGLE_ACTIVE,
        payload: reqData,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

export const deleteCustomer = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CUSTOMER_ADD_LOADER,
        payload: true,
      });
      await axios.post(`${apiUrl}customer/delete`, reqData);
      dispatch({
        type: CUSTOMER_DELETED,
        payload: reqData,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

export const getServerData = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SERVER_ADD_LOADER,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}server/serverData`, reqData);
      dispatch({
        type: SERVER_DATA,
        payload: res.data,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
      dispatch({
        type: SERVER_ADD_LOADER,
        payload: false,
      });
    }
  };
};

export const addServer = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${apiUrl}server/addServer`, reqData);
      dispatch({
        type: SERVER_ADD,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: SERVER_ADD,
        payload: {
          success: false,
          message: "Request error!",
        },
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const editServer = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${apiUrl}server/editServer`, reqData);
      dispatch({
        type: SERVER_EDIT,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: SERVER_EDIT,
        payload: {
          success: false,
          message: "Request error!",
        },
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const setSeverActiveStatus = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SERVER_ADD_LOADER,
        payload: true,
      });
      await axios.post(`${apiUrl}server/setActiveStatus`, reqData);
      dispatch({
        type: SERVER_TOGGLE_ACTIVE,
        payload: reqData,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

export const deleteServer = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SERVER_ADD_LOADER,
        payload: true,
      });
      await axios.post(`${apiUrl}server/delete`, reqData);
      dispatch({
        type: SERVER_DELETED,
        payload: reqData,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

export const resetServerSuccess = (reqData) => {
  return async (dispatch) => {
    dispatch({
      type: SERVER_RESET_SUCCESS,
    });
  };
};

export const resetCustomerSuccess = (reqData) => {
  return async (dispatch) => {
    dispatch({
      type: CUSTOMER_RESET_SUCCESS,
    });
  };
};
export const resetUserSuccess = (reqData) => {
  return async (dispatch) => {
    dispatch({
      type: USER_RESET_SUCCESS,
    });
  };
};

export const getUsers = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.get(`${apiUrl}users/getUser`);
      dispatch({
        type: USER_DATA,
        payload: res.data.data,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

export const addUser = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${apiUrl}users/addUser`, reqData);
      dispatch({
        type: USER_ADD,
        payload: {
          success: true,
        },
      });
    } catch (err) {
      dispatch({
        type: USER_ADD,
        payload: {
          success: false,
          message: "Request error!",
        },
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const editUser = (reqData) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(`${apiUrl}users/editUser`, reqData);
      dispatch({
        type: USER_EDIT,
        payload: {
          success: true,
        },
      });
    } catch (err) {
      dispatch({
        type: USER_EDIT,
        payload: {
          success: false,
          message: "Request error!",
        },
      });
      checkLoginStatus(err, dispatch);
    }
  };
};

export const deleteUser = (reqData) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: USER_ADD_LOADER,
        payload: true,
      });
      const res = await axios.post(`${apiUrl}users/delete`, reqData);
      dispatch({
        type: USER_DELETED,
        payload: reqData,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};

export const getUsersByRole = (reqData) => {
  return async (dispatch) => {
    try {
      const resObj = await axios.get(`${apiUrl}users/getUserByRole`);
      dispatch({
        type: USER_DATA_BY_ROLE,
        payload: resObj.data.data,
      });
    } catch (err) {
      checkLoginStatus(err, dispatch);
    }
  };
};
